import request from '@/utils/request'

// 登录接口
export const postLogin = (params) => {
  const { uuid, ...restProps } = params

  return request({
    method: 'POST',
    url: 'login',
    headers: { uuid },
    params: restProps
  })
}

// 修改密码
export const changePassword = (data) => {
  return request({
    method: 'post',
    url: '/home/password',
    data
  })
}

// 退出登录接口
export const postLogout = () => {
  return request({
    url: '/home/logout'
  })
}

// 获取验证码
export const getCodeImg = (uuid) => {
  return request({
    url: '/captcha/img',
    headers: { uuid },
    method: 'get'
  })
}

export const postImg = (file) => {
  return request({
    method: 'POST',
    // url: 'https://www.ydtncpzlzs.cn:9002/common/web/file/upload',
    url: 'https://www.ydtncpzlzs.cn:9000/common/web/file/upload',
    data: file
  })
}

// WFS 图片上传（发货图片等），返回 { filePath: WFS文件名, imgPath: 相对展示路径 }
export const postWfsImg = (file) => {
  return request({
    method: 'POST',
    url: '/trace/wfs/upload',
    data: file
  })
}

// WFS 图片展示地址（dev 走 /dev-api 代理，prod 同源）
export const wfsImgUrl = (name) => {
  return `${process.env.VUE_APP_BASE_API}/trace/wfs/img/${name}`
}
